import ProfileWidget from './ProfileWidget'

export default ProfileWidget
